import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import Notifications from "vue-notification";
import Vuex from "vuex";

/* fontawesome */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faEdit,
    faCheck,
    faGripLines,
    faWindowClose,
    faTimes,
    faExclamationTriangle,
    faSortAlphaDown,
    faSortAlphaUp,
    faSortNumericDown,
    faSortNumericUp,
    faSpinner,
    faSort,
    faSortUp,
    faSortDown
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
    faEdit,
    faCheck,
    faGripLines,
    faWindowClose,
    faTimes,
    faExclamationTriangle,
    faSortAlphaDown,
    faSortAlphaUp,
    faSortNumericDown,
    faSortNumericUp,
    faSpinner,
    faSort,
    faSortUp,
    faSortDown
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
/* End fontawesome*/

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VeeValidate, { fieldsBagName: "vfields" });
Vue.use(Notifications);
Vue.use(Vuex);

import router from "./router";
import App from "./App.vue";
import store from "./store/Store";
import "./components/VueGlobalMixin";

require("./utils/sendClientErrorsToServer");

new Vue({
    render: h => h(App),
    store,
    router
}).$mount("#app");
